import Swiper from './swiper.vue'
import Slide from './slide.vue'

export {
    Swiper, Slide
}



// WEBPACK FOOTER //
// ./src/components/swiper/index.js